<section class="column-visibility">
    <button class="tertiary-btn" (click)="toggleOverlay()" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
        <span class="icon" [innerHTML]="settingsPanel"></span>
    </button>

    <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="trigger"
        [cdkConnectedOverlayOpen]="overlayOpen()"
        (detach)="closeOverlay()"
        (overlayOutsideClick)="closeOverlay()"
        [cdkConnectedOverlayHasBackdrop]="true"
        cdkConnectedOverlayBackdropClass="cdk-overlay-custom-backdrop"
        (backdropClick)="closeOverlay()"
        [cdkConnectedOverlayPush]="true"
    >
        <div class="column-visibility-overlay">
            <lib-search-input
                placeholderText="Search columns..."
                [searchIcon]="true"
                [text]="searchText()"
                (textChange)="onSearchTextChange($event)"
                [clearValueButton]="true"
            >
            </lib-search-input>
            @if (filteredColumns().length) {
                <ul class="list">
                    <li class="item">
                        <lib-checkbox
                            [disabled]="false"
                            [checked]="allSelected()"
                            checkboxId="all"
                            ariaLabel="All"
                            (checkedChange)="onAllChange($event)"
                        ></lib-checkbox>
                        <label class="item-label" for="all">All</label>
                    </li>
                    @for (column of filteredColumns(); track $index) {
                        <li class="item">
                            <lib-checkbox
                                [(checked)]="column.isSelected"
                                [disabled]="column.isFrozen"
                                [checkboxId]="column.propertyName.toLowerCase()"
                                [ariaLabel]="column.displayName"
                                (checkedChange)="onCheckboxChange()"
                            ></lib-checkbox>
                            <label
                                class="item-label"
                                [class.locked]="column.isFrozen"
                                [for]="column.propertyName.toLowerCase()"
                                >{{ column.displayName }}</label
                            >
                        </li>
                    }
                </ul>
            } @else {
                <div class="no-matches-container">
                    <p class="results">
                        No results for "<strong>{{ searchText() }}</strong
                        >".
                    </p>
                    <p class="suggestions">Try different keywords or check your spelling.</p>
                </div>
            }
            <div class="footer">
                <button (click)="apply()" class="tertiary-btn" aria-label="Apply" [disabled]="!enableApplyBtn()">
                    Apply
                </button>
            </div>
        </div>
    </ng-template>
</section>
